export default __webpack_public_path__ + "static/media/bakanlik_yazisi_1.ccfdb71f.jpg";